module.exports = __webpack_public_path__ + "img/recycled.08084893.jpg";